import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { StudentInsUpdData } from "./StudentInsUpdData";
import { StudentInsUpdReview } from "./StudentInsUpdReview";
import { studentInsert, studentUpdate, studentInsUpdSlice, selectStudentInsUpd } from "../../../redux/student/studentInsUpdSlice";
import ObjectInsUpd from "../../../features/base/page/ObjectInsUpd";
import { classroomStudentsSlice } from "../../../redux/classroom/classroomStudentsSlice";
import { useParams } from "react-router";
import { studentSlice, selectStudent } from "../../../redux/student/studentSlice";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import StudentPageTitle from "../basics/StudentPageTitle";
import StudentPageAvatar from "../basics/StudentPageAvatar";
import { TopBar } from "../../../features/top/TopBar";
import { StudentInsUpdData2 } from "./StudentInsUpdData2";

export function StudentInsUpd() {
    const studentInsUpd = useSelector(selectStudentInsUpd);
    const student = useSelector(selectStudent);
    const dispatch = useAppDispatch();

    const {schoolId, classroomId, studentId} = useParams();
    console.debug(`StudentInsUpd: ${studentId}`);

    const editing = studentId !== undefined;
    const breadcrumbTitle = editing ? "Editar Aluno" : "Nova Aluno";
  
    if(editing) {
      if(studentInsUpd.student.schoolId === "" && student.selected) {
        const changing = {
          ...student.selected
        };
        dispatch(studentInsUpdSlice.actions.set(changing));
      }
    } else {
      if(studentInsUpd.student.schoolId === "") {
        const changing = {
          ...studentInsUpd.student
        };
        changing.schoolId = `${schoolId}`;
        dispatch(studentInsUpdSlice.actions.set(changing));
      }
    }
  
    const breadcrumbs = [ { label: breadcrumbTitle }, ];

    const steps = [
        {
            name: "Dados da aluno",
            component: <StudentInsUpdData />,
            check: () => studentInsUpd.student.name.length > 4,
        },
        {
            name: "Aluno - dados adicionais",
            component: <StudentInsUpdData2 />,
        },
        {
            name: "Revisão",
            component: <StudentInsUpdReview />,
        }
    ];

    const title = (editing) ? <StudentPageTitle studentId={studentId} /> : "Nova aluno";
    const pageAvatar = (editing) ? <StudentPageAvatar /> : undefined;
  
    const buildContent = () => 
        <ObjectInsUpd 
                    name="aluno" 
                    submit={() => (editing)
                        ? dispatch(studentUpdate({student: studentInsUpd.student, studentId: studentId}))
                        : dispatch(studentInsert({student: studentInsUpd.student, classroomId: classroomId}))
                    } 
                    backTo={
                        (editing)? `/school/${schoolId}/student/${studentId}` : `/school/${schoolId}/classroom/${classroomId}/student/add`
                    } 
                    backCleanup={() => {
                        dispatch(classroomStudentsSlice.actions.clean());
                        dispatch(studentSlice.actions.clean());
                        dispatch(studentInsUpdSlice.actions.clean());
                    }}
                    state={studentInsUpd.state} 
                    steps={steps}
                    edit={editing}
          />;

        return <PageAuthenticatedLoading key="editUpdateStudent"
            topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
            loading={{
                states: editing ? [student.state] : [], 
                content: buildContent,
                error: "Erro ao carregar aluno",
                retry: () => {
                dispatch(studentSlice.actions.clean());
                dispatch(studentInsUpdSlice.actions.clean());
                }
            }} />;
                
}
